module.exports = __webpack_public_path__ + "static/Privacystatement-OIG_v2019-10-01-39360233e46b9223b36b570ddf6de1df.pdf";